import { render, staticRenderFns } from "./InsightsReadOnly.vue?vue&type=template&id=28a94ad2&scoped=true"
import script from "./InsightsReadOnly.vue?vue&type=script&lang=js"
export * from "./InsightsReadOnly.vue?vue&type=script&lang=js"
import style0 from "./InsightsReadOnly.vue?vue&type=style&index=0&id=28a94ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a94ad2",
  null
  
)

export default component.exports